'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Right;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Right(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-chevron-right ' + className,
      viewBox: '0 0 6 18' },
    _react2.default.createElement('path', { fill: 'currentColor', d: 'M5.9765625,8.21428571 C5.9765625,8.30133972 5.94308069,8.37834788 5.87611607,8.4453125 L1.1953125,13.1261161 C1.12834788,13.1930807 1.05133972,13.2265625 0.964285714,13.2265625 C0.877231708,13.2265625 0.800223549,13.1930807 0.733258929,13.1261161 L0.231026786,12.6238839 C0.164062165,12.5569193 0.130580357,12.4799111 0.130580357,12.3928571 C0.130580357,12.3058031 0.164062165,12.228795 0.231026786,12.1618304 L4.17857143,8.21428571 L0.231026786,4.26674107 C0.164062165,4.19977645 0.130580357,4.12276829 0.130580357,4.03571429 C0.130580357,3.94866028 0.164062165,3.87165212 0.231026786,3.8046875 L0.733258929,3.30245536 C0.800223549,3.23549074 0.877231708,3.20200893 0.964285714,3.20200893 C1.05133972,3.20200893 1.12834788,3.23549074 1.1953125,3.30245536 L5.87611607,7.98325893 C5.94308069,8.05022355 5.9765625,8.12723171 5.9765625,8.21428571 Z' })
  );
}

Right.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Chevron/Right.js
// module id = 190
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16